import LogoKoinworks from 'assets/images/backoffice/capital/logo-koinworks.png';
import LogoModalku from 'assets/images/backoffice/capital/logo-modalku.png';
import LogoTeralite from 'assets/images/backoffice/capital/logo-taralite.svg';
import React from 'react';
import { browserHistory } from 'react-router';
import Button from '../Button';
import CategoryBorder from './CategoryBorder';
import styles from './ProductCard.css';

function TermLoanProduct() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <CategoryBorder color="yellow" />
        <p className={styles.title}>Term Loan</p>
        <div className={`${styles['logo-wrapper']} ${styles['term-loan']}`}>
          <img className={styles['term-logo']} src={LogoTeralite} />
          <img className={styles['term-logo']} src={LogoKoinworks} />
          <img className={styles['term-logo']} src={LogoModalku} />
        </div>
        <p className={styles.desc}>
          Dapatkan pinjaman modal usaha hingga Rp2 miliar dengan tenor hingga 24
          bulan dari partner terpercaya kami.
        </p>
        <div className={styles['action-wrapper']}>
          <Button
            title="Ajukan Pinjaman"
            onClick={() => browserHistory.push('/capital/term-loan')}
          />
        </div>
        <a
          className={styles.link}
          href="https://www.mokapos.com/lending-id"
          target="_blank"
        >
          Pelajari lebih lanjut
        </a>
      </div>
    </div>
  );
}

export default TermLoanProduct;
